/* ═══════════════════════════════════════════════════════════════════════════════════════════════════════════
   LOOK'S VIEWS: OPEN · CLOSED · BACK · SPIN (24 Oct 2026). Yonatan's review of 22 Oct (#claude-communication), Daniel's go.

   THE BUG IT FIXES. Open / Closed lived in the header (desktop) and on the stage (phone) and only showed on Look. Set
   Closed, step back to Photos or Inside, and the card stayed shut there, with no control on that step to open it.
   Now the views are Look's own, first in its tools above the border, and LEAVING LOOK ALWAYS PUTS THE CARD BACK OPEN
   (the step's natural view), by any road: Back, a step pill, a picture tapped on the card. Next to Send keeps today's
   envelope: from Closed it goes in shut (builder-envelope.js); from Back or Spin the card is put back open first and
   the envelope closes it as it does from Open.

   THE FOUR, the share page's (shared-card.js, "Spin · Closed · Open · Back") on the builder's own card:
     open    today's open card.
     closed  today's fold, exactly (builder-b.js ppbShowClosed → configurator.js foldCard / unfoldCard).
     back    the closed card turned over to its back (CoverBack, v2e): Yonatan's card-geometry-back.json (60 frames,
             0 front up, 59 back up) and card-back(-sm).mp4, video frame i = geometry frame i. The card fades to the
             front-up pose, the turn plays with its shading multiplied over the planes from a canvas (as card-moves.js
             does), and at rest the turned card's still (card-back-shade) is in .pp-shade. Offered only on a design
             with back art, as the share page does.
     spin    the open card floating and turning once in Yonatan's seamless 4 s loop: card-geometry-spin-float.json
             (120 frames) and card-spin-float(-sm).mp4, the video itself multiplied over the planes (no canvas: a
             looping clip read back into a canvas every frame costs megapixels a second for nothing). The planes follow
             the video's own clock (requestVideoFrameCallback, with the rAF watchdog every rVFC loop here carries), so
             art and shading are the same frame. Without a playable clip it turns unshaded on the page's clock.
   Into or out of Back and Spin is a fade (their poses do not chain with the builder's stood-up closed card): the card
   fades out, the pose changes under it, and the new one fades in. Open ↔ Closed is today's fold. Reduced motion: no
   fade, no turn, Spin rests on frame 0.

   THE CAMERA. Back and Spin hold the crop camera by hand (_camDrive) on the union of every frame's boxes, so it never
   moves while the card turns; a resize re-fits it. Leaving hands it back (_camRelease).

   PAGE WEIGHT (page-speed.md). Nothing here is fetched until Back or Spin is tapped: the geometry (34 / 73 KB), the clip
   (the 1000 px copy whenever the painted card is 1200 device px or less, as configurator.js _clipUrl chooses), and for
   Back its still. All fetched whole and played from memory (a streamed loop stalls), kept for the visit.

   Events: pp_look_view { view, from } on every press (analytics/funnel-manifest.json knownEvents).

   Loaded AFTER builder-envelope.js, which it wraps: outermost, so its ppbGo runs first.
   ═══════════════════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  window.PP = window.PP || {};
  const PP = window.PP;
  if (typeof PP.builderB !== 'function') return;
  const U = window.PP_VIEWS;
  if (!U) return;

  const FPS = 30;
  const FADE_OUT_MS = 180, FADE_IN_MS = 240;
  const track = function (ev, props) { try { if (window.PP.track) window.PP.track(ev, props || {}); } catch (e) { /* analytics never breaks the card */ } };
  const reduced = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };

  /* ⛔ SAFARI STOPS CALLING requestVideoFrameCallback PARTWAY THROUGH A CLIP (18 Oct). The same helper is in
     configurator.js, card-moves.js, builder-envelope.js and rd-card3d.js: change all of them or none. */
  function afterFrame(v, cb) {
    let fired = false;
    const t0 = performance.now();
    const rv = !!v.requestVideoFrameCallback && !v._ppRvfcDead;
    if (rv) v.requestVideoFrameCallback(function (now, meta) { if (fired) return; fired = true; cb(meta.mediaTime, true); });
    const poll = function () {
      if (fired) return;
      if (!rv || performance.now() - t0 > 100) {
        if (rv && !v.paused) v._ppRvfcDead = true;
        fired = true; cb(v.currentTime, false); return;
      }
      requestAnimationFrame(poll);
    };
    requestAnimationFrame(poll);
  }

  // Fetched once per visit, kept. A failure is forgotten so the next tap may try again.
  const CACHE = {};
  const once = function (key, make) {
    if (!CACHE[key]) {
      CACHE[key] = make().then(function (v) { CACHE[key].value = v; return v; });
      CACHE[key].catch(function () { delete CACHE[key]; });
    }
    return CACHE[key];
  };
  const loadJSON = function (url) {
    return once('j:' + url, function () {
      return fetch(url).then(function (r) { if (!r.ok) throw new Error('views_geo_' + r.status); return r.json(); })
        .then(function (g) { if (!g || !g.camera || !g.planes) throw new Error('views_geo_bad'); return g; });
    });
  };
  const loadBlob = function (url) {
    return once('b:' + url, function () {
      return fetch(url).then(function (r) { if (!r.ok) throw new Error('views_clip_' + r.status); return r.blob(); })
        .then(function (b) { return URL.createObjectURL(b); });
    });
  };
  const within = function (p, ms) {
    return Promise.race([p.catch(function () { return null; }), new Promise(function (r) { setTimeout(function () { r(null); }, ms); })]);
  };
  const lastOf = function (g) { return (g.frames && g.frames.last != null) ? g.frames.last : Object.keys(g.camera.position).length - 1; };

  /* Kept OUT of the component: Alpine wraps what it stores in reactive proxies, and a proxied <video> throws on pause().
     The component carries only what the page reads (ppbViewMode). */
  const S = { tok: 0, spinVid: null, turnVid: null, cv: null, loopTok: 0, raf: 0, rv: 0, frame: 0, cam: null,
              back: null, spin: null, backBox: null, spinBox: null, shadeWas: null, onResize: null, anims: [] };

  function stageEl() { return document.querySelector('[data-pp-stage]'); }
  function zoomEl() { return document.querySelector('[data-pp-camera]'); }
  function shadeEl() { return document.querySelector('[data-pp-stage] .pp-shade'); }

  function mkVideo(loop) {
    const stage = stageEl();
    if (!stage) return null;
    const v = document.createElement('video');
    v.className = 'pp-shadesrc pp-viewvid';
    ['muted', 'playsinline', 'disablepictureinpicture', 'disableremoteplayback'].forEach(function (a) { v.setAttribute(a, ''); });
    if (loop) v.setAttribute('loop', '');
    v.setAttribute('aria-hidden', 'true');
    v.muted = true; v.playsInline = true; v.loop = !!loop; v.preload = 'auto';
    stage.appendChild(v);
    return v;
  }
  function ready(v, ms) {
    if (v.readyState >= 2) return Promise.resolve(true);
    return new Promise(function (done) {
      const t = setTimeout(function () { done(v.readyState >= 2); }, ms);
      v.addEventListener('loadeddata', function () { clearTimeout(t); done(true); }, { once: true });
      v.addEventListener('error', function () { clearTimeout(t); done(false); }, { once: true });
    });
  }

  // The comp square (the clip's whole 2000 px), placed on the stage from the camera, as card-moves.js places its canvas.
  function place(el, geom, cam) {
    const stage = stageEl(), CS = PP.CardStage;
    if (!el || !stage || !cam || !CS) return;
    const comp = geom.comp.width / (CS.LAYOUT_SCALE || 1);
    const size = comp * cam.scale, W = stage.clientWidth, H = stage.clientHeight;
    el.style.position = 'absolute';
    el.style.width = size.toFixed(1) + 'px';
    el.style.height = size.toFixed(1) + 'px';
    el.style.left = (W / 2 + cam.x - size / 2).toFixed(1) + 'px';
    el.style.top = (H / 2 + cam.y - size / 2).toFixed(1) + 'px';
  }
  // The painted size decides the encode, never the user agent (configurator.js _clipUrl's rule: 1200 device px).
  function small(geom, cam) {
    const CS = PP.CardStage;
    const comp = geom.comp.width / ((CS && CS.LAYOUT_SCALE) || 1);
    return comp * (cam ? cam.scale : 1) * (window.devicePixelRatio || 1) <= 1200;
  }

  // Every frame's boxes, so the camera holds still while the card turns.
  function unionOf(geom) {
    const CS = PP.CardStage;
    let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    for (let f = 0; f <= lastOf(geom); f += 3) {
      const t = CS.frameTransforms(geom, f);
      Object.keys(t.planes).forEach(function (k) {
        const b = t.planes[k].box;
        if (!b) return;
        x0 = Math.min(x0, b.cx - b.w / 2); x1 = Math.max(x1, b.cx + b.w / 2);
        y0 = Math.min(y0, b.cy - b.h / 2); y1 = Math.max(y1, b.cy + b.h / 2);
      });
    }
    if (!isFinite(x0) || x1 <= x0 || y1 <= y0) return null;
    return { cx: (x0 + x1) / 2, cy: (y0 + y1) / 2, w: x1 - x0, h: y1 - y0 };
  }

  function fadeOut(els) {
    S.anims.forEach(function (a) { try { a.cancel(); } catch (e) { /* done */ } });
    S.anims = [];
    if (reduced()) return Promise.resolve();
    els.forEach(function (el) {
      if (el && el.animate) S.anims.push(el.animate([{ opacity: getComputedStyle(el).opacity }, { opacity: 0 }], { duration: FADE_OUT_MS, easing: 'linear', fill: 'forwards' }));
    });
    return new Promise(function (r) { setTimeout(r, FADE_OUT_MS + 20); });
  }
  function fadeIn(els) {
    const was = S.anims;
    S.anims = [];
    if (!reduced()) {
      els.forEach(function (el) {
        if (el && el.animate) S.anims.push(el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: FADE_IN_MS, easing: 'linear' }));
      });
    }
    was.forEach(function (a) { try { a.cancel(); } catch (e) { /* done */ } });
  }

  const inner = PP.builderB;
  PP.builderB = function () {
    const c = inner.apply(this, arguments);
    const base = {
      applyFrame: c.applyFrame, init: c.init, ppbGo: c.ppbGo, toggleFold: c.toggleFold, ppbZoomable: c.ppbZoomable,
      setBorder: c.setBorder, setRounded: c.setRounded, setShadow: c.setShadow,
    };

    Object.assign(c, {
      ppbViewMode: null,     // 'back' | 'spin' while the card is in one of them (or fading into it); null otherwise

      ppbView() { return this.ppbViewMode || (this.foldedInEditor ? 'closed' : 'open'); },
      ppbViews() {
        const out = [{ key: 'open', label: 'Open' }, { key: 'closed', label: 'Closed' }];
        if (typeof this.designArt === 'function' && this.designArt('CoverBack')) out.push({ key: 'back', label: 'Back' });
        out.push({ key: 'spin', label: 'Spin' });
        return out;
      },

      ppbSetView(to) {
        if (this.stage !== 'builder' || this.ppbStep !== this.ppbShowStep()) return;
        const from = this.ppbView();
        if (to === from) return;
        if (typeof this.photosLoading === 'function' && this.photosLoading()) return;   // nothing to show yet
        track('pp_look_view', { view: to, from: from });
        // Open ↔ Closed is today's fold, exactly.
        if (!this.ppbViewMode && !S.busy && (to === 'open' || to === 'closed')) { this.ppbShowClosed(to === 'closed'); return; }
        this._pvFade(to);
      },

      _pvFade(to) {
        const self = this, tok = ++S.tok;
        S.busy = to;
        this.ppbViewMode = (to === 'back' || to === 'spin') ? to : null;   // the radio says the choice at once
        const els = [zoomEl(), S.spinVid, S.cv];
        const want = to === 'spin' ? loadJSON(U.spinGeo) : to === 'back' ? loadJSON(U.backGeo) : Promise.resolve(null);
        Promise.all([fadeOut(els), within(want, 4000)]).then(function (res) {
          if (tok !== S.tok) return;
          const geom = res[1];
          self._pvExit();
          if (to === 'back' && geom) self._pvBack(geom, tok);
          else if (to === 'spin' && geom) self._pvSpin(geom, tok);
          else self._pvMain(to === 'closed' || to === 'back');      // no geometry: the nearest view we can show
          S.busy = null;
          requestAnimationFrame(function () { if (tok === S.tok) fadeIn([zoomEl(), S.spinVid, S.cv]); });
        });
      },

      // Out of Back or Spin: loops stop, the clips hide (kept loaded), the shade and the classes come back. The
      // camera is NOT released here: whoever rests next decides.
      _pvExit() {
        S.loopTok++;
        cancelAnimationFrame(S.raf); S.raf = 0;
        if (S.rv && S.spinVid && S.spinVid.cancelVideoFrameCallback) { try { S.spinVid.cancelVideoFrameCallback(S.rv); } catch (e) { /* gone */ } }
        S.rv = 0;
        [S.spinVid, S.turnVid].forEach(function (v) { if (v) { try { v.pause(); } catch (e) { /* gone */ } v.style.display = 'none'; } });
        if (S.cv) S.cv.style.display = 'none';
        const vp = stageEl();
        if (vp) vp.classList.remove('pp-viewport--vback', 'pp-viewport--vspin');
        const sh = shadeEl();
        if (sh && S.shadeWas !== null) { sh.style.backgroundImage = S.shadeWas; S.shadeWas = null; }
        if (S.onResize) { window.removeEventListener('resize', S.onResize); S.onResize = null; }
        S.cam = null;
      },

      // Today's open or closed card, at rest, camera handed back.
      _pvMain(closed) {
        this.ppbViewMode = null;
        if (this._previewStop) this._previewStop();
        this.closing = false;
        this.cardClosed = !!closed;
        this.foldedInEditor = !!closed;
        this.cardFrame = closed ? 100 : 0;
        try { base.applyFrame.call(this, this.cardFrame, closed && this._standGeom ? this._standGeom(1) : null); } catch (e) { /* the next frame will */ }
        this._camRelease();
      },

      _pvHold(geom, box) {
        const self = this;
        const fit = function () {
          const cam = self._fitU(box, 0.94);
          S.cam = cam;
          self._camDrive(cam);
          return cam;
        };
        S.onResize = function () {
          if (!self.ppbViewMode) return;
          const cam = fit();
          if (S.cv && S.cv.style.display !== 'none') place(S.cv, geom, cam);
          if (S.spinVid && S.spinVid.style.display !== 'none') place(S.spinVid, geom, cam);
        };
        window.addEventListener('resize', S.onResize);
        return fit();
      },

      _pvBack(geom, tok) {
        const self = this, CS = PP.CardStage;
        S.back = geom;
        if (!S.backBox) S.backBox = unionOf(geom);
        this.ppbViewMode = 'back';
        if (this._previewStop) this._previewStop();
        this.closing = false;
        this.cardClosed = true;          // the shut card: .pp-viewport--closed hides the folded stack under the cover
        this.foldedInEditor = true;
        this.cardFrame = 100;
        const vp = stageEl();
        if (vp) vp.classList.add('pp-viewport--vback');
        const cam = this._pvHold(geom, S.backBox);
        const n = lastOf(geom);
        const sm = small(geom, cam);
        const rest = function () {
          if (tok !== S.tok) return;
          S.frame = n;
          base.applyFrame.call(self, n, geom);
          const sh = shadeEl();
          if (sh) {
            if (S.shadeWas === null) S.shadeWas = sh.style.backgroundImage;
            sh.style.backgroundImage = 'url("' + (sm ? U.backShadeSm : U.backShade) + '")';
          }
          if (S.cv) S.cv.style.display = 'none';
          if (vp) vp.classList.remove('pp-viewport--vturning');
        };
        if (reduced() || !CS) { rest(); return; }
        // The turn: front up to back up, the clip's shading over the planes from a canvas. The still waits for the end.
        S.frame = 0;
        base.applyFrame.call(this, 0, geom, true);
        if (vp) vp.classList.add('pp-viewport--vturning');
        const my = ++S.loopTok;
        const clock = function () {         // no clip: the turn on the page's clock, unshaded, 2 s
          const t0 = performance.now();
          const step = function (now) {
            if (my !== S.loopTok) return;
            const i = Math.min(n, Math.round((now - t0) / 1000 * FPS));
            base.applyFrame.call(self, i, geom, true);
            if (i >= n) { rest(); return; }
            S.raf = requestAnimationFrame(step);
          };
          S.raf = requestAnimationFrame(step);
        };
        within(loadBlob(sm ? U.backSm : U.back), 1200).then(function (src) {
          if (my !== S.loopTok || tok !== S.tok) return;
          if (!src) { clock(); return; }
          if (!S.turnVid) S.turnVid = mkVideo(false);
          const v = S.turnVid;
          if (!v) { clock(); return; }
          if (v.getAttribute('src') !== src) { v.src = src; try { v.load(); } catch (e) { /* loads on play */ } }
          ready(v, 1500).then(function (ok) {
            if (my !== S.loopTok || tok !== S.tok) return;
            if (!ok) { clock(); return; }
            if (!S.cv) {
              S.cv = document.createElement('canvas');
              S.cv.className = 'pp-shadevid pp-viewcanvas';
              S.cv.setAttribute('aria-hidden', 'true');
              stageEl().appendChild(S.cv);
            }
            const cv = S.cv;
            const px = Math.min(2048, Math.round((geom.comp.width / (CS.LAYOUT_SCALE || 1)) * cam.scale * (window.devicePixelRatio || 1)));
            if (cv.width !== px) { cv.width = px; cv.height = px; }
            const cx = cv.getContext('2d', { alpha: true });
            if (cx) { cx.imageSmoothingEnabled = true; cx.imageSmoothingQuality = 'high'; }
            place(cv, geom, S.cam || cam);
            cv.style.display = 'block';
            cv.style.animation = 'none';
            let last = -1;
            const frame = function (i) {
              if (i === last) return;
              last = i;
              base.applyFrame.call(self, i, geom, true);
              if (cx && v.videoWidth) { cx.clearRect(0, 0, cv.width, cv.height); cx.drawImage(v, 0, 0, cv.width, cv.height); }
            };
            let seq = 0;
            const step = function (t) {
              seq++;
              if (my !== S.loopTok) return;
              const i = Math.min(n, Math.max(0, Math.round(t * FPS)));
              frame(i);
              if (i >= n || v.ended) { frame(n); rest(); return; }
              const s = seq;
              afterFrame(v, function (tt) { if (s === seq) step(tt); });
              setTimeout(function () { if (s === seq) step(v.currentTime); }, 250);   // a hidden tab: rAF stops too
            };
            try { v.currentTime = 0; } catch (e) { /* at 0 */ }
            frame(0);
            const p = v.play();
            step(0);
            if (p && p.catch) p.catch(function () { if (my === S.loopTok) { cv.style.display = 'none'; seq++; clock(); } });
          });
        });
      },

      _pvSpin(geom, tok) {
        const self = this;
        S.spin = geom;
        if (!S.spinBox) S.spinBox = unionOf(geom);
        this.ppbViewMode = 'spin';
        if (this._previewStop) this._previewStop();
        this.closing = false;
        this.cardClosed = false;
        this.foldedInEditor = false;
        this.cardFrame = 0;
        const vp = stageEl();
        if (vp) vp.classList.add('pp-viewport--vspin');
        const cam = this._pvHold(geom, S.spinBox);
        const n = lastOf(geom) + 1;
        const pose = function (f) { S.frame = f; base.applyFrame.call(self, f, geom, true); };
        pose(S.frame % n || 0);
        if (reduced()) { pose(0); return; }
        const my = ++S.loopTok;
        const clock = function () {
          if (S.spinVid) S.spinVid.style.display = 'none';
          const t0 = performance.now(), f0 = S.frame;
          const step = function (now) {
            if (my !== S.loopTok) return;
            pose((f0 + Math.floor((now - t0) / 1000 * FPS)) % n);
            S.raf = requestAnimationFrame(step);
          };
          S.raf = requestAnimationFrame(step);
        };
        // Turning on the page's clock at once; the clip's shading joins when it is in.
        clock();
        loadBlob(small(geom, cam) ? U.spinSm : U.spin).then(function (src) {
          if (my !== S.loopTok || tok !== S.tok) return;
          if (!S.spinVid) S.spinVid = mkVideo(true);
          const v = S.spinVid;
          if (!v) return;
          v.classList.add('pp-viewspin');
          if (v.getAttribute('src') !== src) { v.src = src; try { v.load(); } catch (e) { /* loads on play */ } }
          return ready(v, 8000).then(function (ok) {
            if (!ok || my !== S.loopTok || tok !== S.tok) return;
            const f0 = S.frame;
            try { v.currentTime = f0 / FPS; } catch (e) { /* from 0 */ }
            const p = v.play();
            const go = function () {
              if (my !== S.loopTok) return;
              cancelAnimationFrame(S.raf); S.raf = 0;
              place(v, geom, S.cam || cam);
              v.style.display = 'block';
              const next = function () {
                if (my !== S.loopTok) return;
                afterFrame(v, function (t) {
                  if (my !== S.loopTok) return;
                  pose(((Math.round(t * FPS) % n) + n) % n);
                  next();
                });
              };
              next();
            };
            if (p && p.then) p.then(go, function () { /* refused: the clock keeps turning it, unshaded */ });
            else go();
          });
        }).catch(function () { /* the clock keeps turning it, unshaded */ });
      },

      // Leaving Look: the card goes back to the step's natural view, open. Instant, like configurator.js
      // _restoreOpenPose: they asked for another step, not an animation on the way to it. Next to Send from Closed
      // keeps today's shut envelope.
      _pvLeave(key) {
        if (this.ppbViewMode || S.busy) {
          ++S.tok; S.busy = null;
          fadeIn([]);                       // cancels a fade in flight; opacity back to the stylesheet's
          this._pvExit();
          this._pvMain(false);
          return;
        }
        if (this.foldedInEditor && key !== 'send' && typeof this._restoreOpenPose === 'function') this._restoreOpenPose();
      },

      ppbGo(key) {
        if (this.stage === 'builder' && this.ppbStep === this.ppbShowStep() && key && key !== this.ppbStep) this._pvLeave(key);
        return base.ppbGo.apply(this, arguments);
      },

      // A tap that would fold or unfold the card while it is turned or turning: back to Open instead.
      toggleFold() {
        if (this.ppbViewMode) { this.ppbSetView('open'); return; }
        return base.toggleFold.apply(this, arguments);
      },

      ppbZoomable() { return !this.ppbViewMode && base.ppbZoomable.apply(this, arguments); },

      // Every caller that re-applies the card's frame (a resize, the tray settling) gets the pose the view is in.
      applyFrame(frame, geomOverride, quiet) {
        if (!geomOverride && this.ppbViewMode === 'back' && S.back && !S.busy) return base.applyFrame.call(this, S.frame, S.back, quiet);
        if (!geomOverride && this.ppbViewMode === 'spin' && S.spin && !S.busy) return base.applyFrame.call(this, S.frame, S.spin, true);
        return base.applyFrame.apply(this, arguments);
      },

      init() {
        const out = base.init ? base.init.apply(this, arguments) : undefined;
        const self = this;
        if (typeof this.$watch === 'function') {
          // Any other road off Look (a picture tapped on the card moves the section, and the step follows it).
          this.$watch('ppbStep', function (to, from) {
            if (from === self.ppbShowStep() && to !== from) self._pvLeave(to);
          });
          this.$watch('stage', function (st) { if (st !== 'builder' && (self.ppbViewMode || S.busy)) self._pvLeave('close'); });
        }
        return out;
      },
    });

    // A change to the card's look while it is shut, turned or turning: open it, so the change is seen.
    ['setBorder', 'setRounded', 'setShadow'].forEach(function (k) {
      if (typeof base[k] !== 'function') return;
      c[k] = function () {
        if (this.ppbStep === this.ppbShowStep() && this.ppbView() !== 'open') this.ppbSetView('open');
        return base[k].apply(this, arguments);
      };
    });
    return c;
  };
})();
